import styles from './styles.module.scss'

export default function PageSection({
  isThinSpacing,
  classes,
  children,
  id
}: {
  isThinSpacing?: boolean
  classes?: string
  children: React.ReactNode
  id?: string
}) {
  return (
    <section
      id={id}
      className={`${styles.SectionSpacing} ${
        isThinSpacing ? styles.SectionSpacingThin : ''
      } ${classes || ''}`}
    >
      {children}
    </section>
  )
}
